import React from 'react';
import { Link } from 'react-router-dom';

const HeroHeader = () => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="text-xl font-light text-gray-800 hover:text-gray-600 transition-colors">
            RRAMMY
          </Link>

          {/* Navigation */}
          <nav className="flex items-center space-x-8">
            <Link
              to="/"
              className="text-sm font-light text-gray-600 hover:text-gray-900 transition-colors"
            >
              Expresso Films
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default HeroHeader;